import React from "react";
import { useNavigate } from "react-router-dom";

const ButtonCta = ({
  title = "شروع مشاوره لانجویتی:",
  className = "max-w-5xl mx-auto flex justify-between items-center max-md:flex-col  p-6 rounded-lg border-2 border-bgBlue shadow-md ",
}) => {
  const navigate = useNavigate();
  return (
    <section className=" h-auto   p-6 mt-6">
      <div className={className}>
        <div className="flex flex-col items-start max-md:items-center">
          <h2 className=" font-bold text-lg  mb-4">{title}</h2>
          <p className=" text-gray-700">
            با پر کردن فرم ارزیابی می‌توانید، فرایند مشاوره‌ی لانجویتی را شروع
            کنید.{" "}
          </p>
        </div>
        <button
          className="bg-bgBlue text-md   text-white px-4  py-2 w-fit rounded-lg flex items-center gap-2 cursor-pointer group max-md:mt-8 max-md:mx-auto font-bold hover:scale-105 transition-all duration-300  "
          onClick={() => navigate("/form")}
        >
          <span className=" mx-auto">تکمیل فرم ارزیابی</span>
        </button>
      </div>
    </section>
  );
};

export default ButtonCta;
